// pro solid icons (fas)
const icons = [
    'faArrowAltRight',
    'faBookmark',
    'faCaretDown',
    'faCaretUp',
    'faCircle',
    'faColumns',
    'faDollarSign',
    'faSortDown',
    'faFilter',
    'faFlag',
    'faGlobeAmericas',
    'faMapMarkerAlt',
    'faPeoplePantsSimple',
    'faPeopleRoof',
    'faStar',
    'faStarHalfAlt',
    'faSort',
    'faSortUp',
    'faUnlock',
    'faUsers',
    'faPrescriptionBottle',
    'faPersonCirclePlus',
    'faFlask',
    'faHeading',
    'faArrowUp',
    'faChartPie',
    'faTriangleExclamation',
];

// Import all icons
import * as iconsModule from '@fortawesome/pro-solid-svg-icons';

export default (library) => {
    // Add all icons to the library
    icons.forEach((iconName) => {
        if (iconsModule[iconName]) {
            library.add(iconsModule[iconName]);
        }
    });
};
